<template>
  <div class="managementList">
    <div class="filter">
      <div class="filter_item">
        <div class="filter_item_label">标题</div>
        <el-input class="filter_item_input" v-model.trim="form.title" clearable placeholder="请输入文字模糊搜索"></el-input>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">公告类型</div>
        <el-select class="filter_item_select" v-model="form.announcementType" clearable placeholder="请选择">
          <el-option label="系统更新" :value="1"></el-option>
          <el-option label="运营通知" :value="2"></el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">是否弹窗提示</div>
        <el-select class="filter_item_select" v-model="form.popup" clearable placeholder="请选择">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">发布状态</div>
        <el-select class="filter_item_select" v-model="form.status" clearable placeholder="请选择">
          <el-option label="已发布" :value="1"></el-option>
          <el-option label="未发布" :value="0"></el-option>
          <el-option label="已下线" :value="2"></el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <div class="filter_item_label">发布时间</div>
        <el-date-picker
          class="filter_item_date"
          v-model="form.publishTime"
          type="daterange"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="filter_action">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="toNotificationEdit('add', null)">新建公告</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column prop="title" label="标题" min-width="180" show-overflow-tooltip fixed="left">
          <template slot-scope="scope">
            <div class="table_title">
              <span v-if="scope.row.top" class="table_title_top">置顶</span>
              <span>{{ scope.row.title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="announcementType" label="公告类型" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.announcementType === 1">系统更新</div>
            <div v-if="scope.row.announcementType === 2">运营通知</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">未发布</div>
            <div v-if="scope.row.status === 1">已发布</div>
            <div v-if="scope.row.status === 2">已下线</div>
          </template>
        </el-table-column>
        <el-table-column label="已读/未读" min-width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">-</div>
            <div v-else>已读 {{ scope.row.readCount }} / 未读 {{ scope.row.unreadCount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="popup" label="是否弹窗提示" min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.popup ? '是' : '否' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="publishTime" label="发布时间" min-width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">-</div>
            <div v-else>{{ scope.row.publishTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
        <el-table-column prop="createBy" label="创建人" min-width="120"></el-table-column>
        <el-table-column prop="publishBy" label="发布人" min-width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">-</div>
            <div v-else>{{ scope.row.publishBy }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0" type="text" @click="toNotificationEdit('edit', scope.row.announcementId)">编辑</el-button>
            <el-button v-if="scope.row.status !== 0" type="text" @click="toNotificationEdit('view', scope.row.announcementId)">详情</el-button>
            <el-button v-if="scope.row.status === 1" type="text" @click="topChange(scope.row)">{{ scope.row.top ? '取消置顶' : '置顶' }}</el-button>
            <el-button v-if="scope.row.status === 0" type="text" @click="publishNotification(scope.row)">发布公告</el-button>
            <el-button v-if="scope.row.status === 1" type="text" @click="offlineNotification(scope.row)">下线</el-button>
            <el-button v-if="scope.row.status === 0" type="text" style="color: #F56C6C;" @click="deleteNotification(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        :current-page="pageNo"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="pageNoChange">
      </el-pagination>
    </div>

    <notificationEdit ref="notificationEdit" @confirm="notificationEithConfirm"></notificationEdit>
  </div>
</template>

<script>
  import req from '@/utils/request'

  import notificationEdit from './notificationEdit.vue'

  export default {
    name: 'managementList',
    components: {
      notificationEdit
    },
    data() {
      return {
        form: {
          title: '',
          announcementType: '',
          popup: '',
          status: '',
          publishTime: []
        },
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0
      }
    },
    created () {
      this.getList()
    },
    methods: {
      async getList () {
        const res = await req.post('/announcement/manage/page', {
          ...this.form,
          publishStartTime: this.form.publishTime && this.form.publishTime.length > 0 ? this.form.publishTime[0] : null,
          publishEndTime: this.form.publishTime && this.form.publishTime.length > 0 ? this.form.publishTime[1] : null,
          pageNum: this.pageNo,
          pageSize: this.pageSize
        })
        this.list = res.rows
        this.total = res.total
      },
      pageNoChange (pageNo) {
        this.pageNo = pageNo
        this.getList()
      },
      search () {
        this.pageNo = 1
        this.getList()
      },
      reset () {
        this.form = {
          title: '',
          announcementType: '',
          popup: '',
          status: '',
          publishTime: []
        }
        this.pageNo = 1
        this.getList()
      },
      toNotificationEdit (type = 'add', id = null) {
        this.$refs.notificationEdit.open(type, id)
      },
      topChange (row) {
        if (row.top) {
          this.$confirm('确认取消置顶?', '操作确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await req.post('/announcement/manage/untop', {
              announcementId: row.announcementId,
              version: row.version
            })
            if (res.code === 200) {
              this.$message.success('取消置顶成功')
              this.getList()
            }
          }).catch(() => {})
        } else {
          this.$confirm('确认置顶该公告?', '操作确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await req.post('/announcement/manage/top', {
              announcementId: row.announcementId,
              version: row.version
            })
            if (res.code === 200) {
              this.$message.success('置顶成功')
              this.getList()
            }
          }).catch(() => {})
        }
      },
      publishNotification (row) {
        this.$confirm(`确认发布公告「${row.title}」?`, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await req.post('/announcement/manage/publish', {
            announcementId: row.announcementId,
            version: row.version
          })
          if (res.code === 200) {
            this.$message.success('发布成功')
            this.getList()
          }
        }).catch(() => {})
      },
      offlineNotification (row) {
        this.$confirm(`下线后将不再展示该公告，确认下线？?`, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await req.post('/announcement/manage/offline', {
            announcementId: row.announcementId,
            version: row.version
          })
          if (res.code === 200) {
            this.$message.success('下线成功')
            this.getList()
          }
        }).catch(() => {})
      },
      deleteNotification (row) {
        this.$confirm(`确认删除「${row.title}」?`, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await req.post('/announcement/manage/delete', {
            announcementId: row.announcementId,
            version: row.version
          })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        }).catch(() => {})
      },
      notificationEithConfirm () {
        this.getList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .managementList {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  .filter_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .filter_item_label {
    flex-shrink: 0;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
  }

  .filter_item_input {
    margin: 0 0 0 12px;
    width: 200px;
  }

  .filter_item_select {
    margin: 0 0 0 12px;
    width: 160px;
  }

  .filter_item_date {
    margin: 0 0 0 12px;
    width: 240px;
  }

  .filter_item_date /deep/ .el-range__close-icon {
    line-height: 24px;
  }

  .filter_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .table {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .table_title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .table_title_top {
    margin: 0 4px 0 0;
    padding: 1px 4px;
    font-size: 12px;
    color: #E6A23C;
    background-color: #faecd8;
    border: 1px solid #E6A23C;
    border-radius: 4px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }
</style>
